module.exports = __webpack_public_path__ + "static/media/logo_elecciones26m.f90a0be5.svg";